import React, { useState, useEffect, useRef } from 'react';
import { useQuoteState } from "./quoteState";
import { formDataFromStorage } from '../utils';
import { getCookie, setCookie } from '../../utils/utils';
import { useFormatUSD } from '../../utils/formatting';


import { PlusIcon, MinusIcon, TrashIcon } from '../../utils/icons';


const RecapQuoteItem = ({item}) => {

  // const { updateItem } = useQuoteState();
  // const { items, updateItem, shippingRates, isLoadingShipping, showShippingResults, shippingError, shippingEstimaateAddress } = useQuoteState();
  const { items, updateItem } = useQuoteState();

  

  const optionList = Array.isArray(item.options) ? item.options : [];
  // const [optionsExpanded, setOptionsExpanded] = useState(false);
  // const visibleOptions = optionList.slice(0, 3);
  // const hiddenOptions = optionList.slice(3);

  const renderOption = (option, idx) => (
    <li key={`${option.key ?? 'opt'}-${idx}`}>
      {String(option.label ?? '').replace('_', '')}: {option.value}
    </li>
  );
  
  return (
    
    <div className="mini-cart__line-item">

        <div className="mini-cart__image-wrapper">
          <div className={`aspect-ratio ${item.aspectRatio < 1 ? "aspect-ratio--square" : ""}`} style={{ paddingBottom: `${100 / item.aspectRatio}%` }}>
            <a href={item.url} target="_blank">
              <img src={item.featuredImage} width="95px" alt={item.title} />  
            </a>
          </div>
        </div>

        <div className="mini-cart__item-wrapper">
          <div className="mini-cart__product-info">
            <a href={ item.url } className="mini-cart__product-title text--strong link">{ item.title } - { item.variantTitle }</a>

            {optionList.length > 0 ? (
              <>
                <ul className="mini-cart__property-list" style={{ marginBottom: 0 }}>
                  {optionList.map(renderOption)}
                </ul>


                {/* <ul className="mini-cart__property-list" style={{ marginBottom: 0 }}>
                  {visibleOptions.map(renderOption)}
                </ul>

                {hiddenOptions.length > 0 && (
                  <>
                    <div
                      id={`quote-item-options-${item.id}`}
                      className={`card__collapsible ${optionsExpanded ? 'expanded' : ''}`}
                      style={{ height: optionsExpanded ? 'auto' : '0' }}
                      aria-hidden={!optionsExpanded}
                    >
                      <ul className="mini-cart__property-list" style={{ marginTop: 0 }}>
                        {hiddenOptions.map(renderOption)}
                      </ul>
                    </div>

                    <button
                      type="button"
                      className="link link--primary link--underline link--underline--offset"
                      onClick={() => setOptionsExpanded((v) => !v)}
                      aria-expanded={optionsExpanded}
                      aria-controls={`quote-item-options-${item.id}`}
                      style={{ marginTop: 0, fontSize: '0.9em' }}
                    >
                      {optionsExpanded ? 'View less' : `View more (${hiddenOptions.length})`}
                    </button>
                  </>
                )} */}
              </>
            ) : null}

            {/* <div className="mini-cart__price-list">
              <p className="item-price">{useFormatUSD(item.price * item.quantity / 100)}</p>
            </div> */}

          {!item.tags?.includes('Hide Price') && (
            <div className="mini-cart__price-list">
              { item.compareAtPrice ? (
                <>
                  <span className="price price--highlight">{useFormatUSD(item.price * item.quantity / 100)}</span>
                  <span className="price price--compare price--msrp">MSRP: </span>
                  <span className="price price--compare" aria-label="Compare At Price">{useFormatUSD(item.compareAtPrice * item.quantity / 100)}</span>
                </>
              ) : <span className="price">{useFormatUSD(item.price * item.quantity / 100)}</span> }
            </div>
            )}
          </div>

          <div className="mini-cart__quantity">
            <div className="quantity-selector quantity-selector__quote">
              <button type="button" className="quantity-selector__button qty-minus"  onClick={() => updateItem(item, {quantity: item.quantity - 1})} aria-label="Decrease quantity by 1" title="Decrease quantity by 1"><MinusIcon /></button>
              <input className="quantity-selector__value" type="text" value={item.quantity} min="0" pattern="[0-9]*" onChange={(e) => updateItem(item, { quantity: parseInt(e.target.value) || 0 })} />
              <button type="button"className="quantity-selector__button qty-plus" onClick={() => updateItem(item, {quantity: item.quantity + 1})} aria-label="Increase quantity by 1" title="Increase quantity by 1"><PlusIcon /></button>

              <button type="button" className="button qty-delete hidden-tablet-and-up" onClick={() => updateItem(item, { quantity: 0 })}><TrashIcon /></button>
            </div>
            <button type="button" className="mini-cart__quantity-remove qty-delete hidden-phone" onClick={() => updateItem(item, {quantity: 0})}>Remove</button>

            

          </div>
        </div>

    </div>


    
  );
}
  
  
  
export const QuoteRecapEstimateShipping = () => {
  const { items, totalPrice, totalSavings } = useQuoteState();

  const [formData, setFormData] = useState(formDataFromStorage());
  const [shippingError, setShippingError] = useState(null);
  const [isLoadingShipping, setIsLoadingShipping] = useState(false);
  const [showShippingResults, setShowShippingResults] = useState(false);
  const [shippingRates, setShippingRates] = useState([]);
  const itemsRef = useRef();
  const addressKeyRef = useRef();
  const shippingRequestTokenRef = useRef(0);

  // Helper function to check if zip code is valid (at least 5 digits)
  const isZipCodeValid = (zipCode) => {
    if (!zipCode) return false;
    const digitsOnly = zipCode.replace(/\D/g, '');
    return digitsOnly.length >= 5;
  };

  // Listen for form data changes
  useEffect(() => {
    // Sync formData on mount to ensure we have the latest data
    // setFormData(formDataFromStorage());
    
    const handleStorageChange = () => setFormData(formDataFromStorage());
    const handleFormDataChange = () => setFormData(formDataFromStorage());
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('formDataUpdated', handleFormDataChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('formDataUpdated', handleFormDataChange);
    };
  }, []);

  // Clear shipping results when items change
  useEffect(() => {
    const itemsKey = JSON.stringify(items.map(item => ({ id: item.id, variantId: item.variantId, quantity: item.quantity })));
    
    if (itemsRef.current && itemsRef.current !== itemsKey) {
      setShowShippingResults(false);
      setShippingRates([]);
      setShippingError(null);
    }
    
    itemsRef.current = itemsKey;
  }, [items]);

  // Reset shipping UI when zip or state changes (address no longer matches last estimate)
  useEffect(() => {
    const key = `${formData.zip_code ?? ''}|${formData.state ?? ''}`;
    if (addressKeyRef.current !== undefined && addressKeyRef.current !== key) {
      shippingRequestTokenRef.current += 1;
      setShowShippingResults(false);
      setShippingRates([]);
      setShippingError(null);
      setIsLoadingShipping(false);
    }
    addressKeyRef.current = key;
  }, [formData.zip_code, formData.state]);


  const fetchShippingRates = async () => {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    if (!formData.zip_code || !formData.state) {
      setShippingError('Please fill in your zip code and state to calculate shipping rates.');
      return;
    }
    
    // Validate zip code is at least 5 digits
    const zipCodeDigits = formData.zip_code.replace(/\D/g, '');
    if (zipCodeDigits.length < 5) {
      setShippingError('Zip code must be at least 5 digits.');
      return;
    }
    
    // console.log('state - fetchShippingRates', formData.state, formData.zip_code);

    if (items.length === 0) {
      setShippingError('Please add items to your quote before calculating shipping rates.');
      return;
    }

    setIsLoadingShipping(true);
    setShippingError(null);
    setShowShippingResults(false);

    const shippingRequestToken = ++shippingRequestTokenRef.current;
    let originalCartCookie = null;
    try {
      originalCartCookie = getCookie('cart');
      
      const tempCookieValue = `temp-cart-cookie___${Date.now()}_${Math.floor(Math.random() * 1000)}`;
      
      // updateCartCookie(tempCookieValue);
      setCookie('cart', tempCookieValue, 14);
      
      const tempCartItems = items.map(item => ({
        id: item.variantId,
        quantity: item.quantity,
        properties: item.options ? item.options.reduce((acc, option) => ({
          ...acc,
          [option.key.replace('_', '')]: option.value
        }), {}) : {}
      }));

      const addToCartResponse = await fetch(`${window.routes?.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: tempCartItems })
      });

      if (!addToCartResponse.ok) {
        throw new Error('Failed to add items to temporary cart');
      }

      // Get the new cart cookie after adding items
      const newCartCookie = getCookie('cart');
      
      if (!newCartCookie || newCartCookie.length < 32) {
        if (originalCartCookie) {
          // updateCartCookie(originalCartCookie);
          setCookie('cart', originalCartCookie, 14);
        } else {
          // updateCartCookie('');
          setCookie('cart', '', 14);
        }
        if (shippingRequestTokenRef.current === shippingRequestToken) {
          setShippingError('Unable to calculate shipping rates. Please try again.');
        }
        return;
      }

      // Fetch shipping rates with the temporary cart
      const response = await fetch(
        `${window.routes?.cartUrl || '/cart'}/shipping_rates.json?shipping_address[zip]=${formData.zip_code}&shipping_address[country]=US&shipping_address[province]=${formData.state}`,
        {
          credentials: 'same-origin',
          method: 'GET'
        }
      );

      if (shippingRequestTokenRef.current !== shippingRequestToken) {
        if (originalCartCookie) {
          // updateCartCookie(originalCartCookie);
          setCookie('cart', originalCartCookie, 14);
        } else {
          // updateCartCookie('');
          setCookie('cart', '', 14);
        }
        return;
      }

      if (response.ok) {
        const result = await response.json();
        const rates = result.shipping_rates || [];
        if (shippingRequestTokenRef.current === shippingRequestToken) {
          setShippingRates(rates);
          setShowShippingResults(true);
          if (rates.length === 0) {
            setShippingError('No shipping estimate was returned for this address. Try another ZIP or contact us for a quote.');
          }
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }
      } else {
        let msg = 'Unable to fetch shipping rates. Please try again.';
        try {
          const errBody = await response.json();
          if (errBody && (errBody.message || errBody.description || errBody.error)) {
            msg = String(errBody.message || errBody.description || errBody.error);
          }
        } catch (_) {
          /* ignore non-JSON error bodies */
        }
        if (shippingRequestTokenRef.current === shippingRequestToken) {
          setShippingError(msg);
        }
      }

      // Clear the temporary cart and restore original cart cookie
      if (originalCartCookie) {
        // updateCartCookie(originalCartCookie);
        setCookie('cart', originalCartCookie, 14);
      } else {
        // If there was no original cart, clear the current one
        // updateCartCookie('');
        setCookie('cart', '', 14);
      }

    } catch (err) {
      if (shippingRequestTokenRef.current === shippingRequestToken) {
        setShippingError('An error occurred while calculating shipping rates.');
      }
      console.error('Shipping rate calculation error:', err);

      if (originalCartCookie) {
        // updateCartCookie(originalCartCookie);
        setCookie('cart', originalCartCookie, 14);
      } else {
        // updateCartCookie('');
        setCookie('cart', '', 14);
      }
    } finally {
      if (shippingRequestTokenRef.current === shippingRequestToken) {
        setIsLoadingShipping(false);
      }
    }
  };


  
  if (!items) return null;


  return (

    <div className="cart-recap__scroller">
      <div className="card">
        <div  className="card__section">

          <div className="cart-recap__price-line text--pull">
            <span className="cart-recap__price-line-label">Quote Summary:</span>
            {/* <span className="cart-recap__price-line-price">{useFormatUSD(totalPrice / 100)}</span> */}
          </div>
            
      
          <div id="quote-recap-inner" className="quote-recap-inner" >
            <div className="mini-cart__inner" >
              
              <div className="mini-cart__content">
                <div className="mini-quote-wrapper">
                  <div className="mini-cart__line-item-list">
                  {items.map((item) => (
                      <RecapQuoteItem key={item.id} item={item}/>
                  ))}
                  </div>
                </div>
              </div>

              <div className="mini-cart__recap">

                {totalSavings > 0 && (
                  <div className="mini-cart__recap-price-line">
                    <span className="item-price-label">Your Savings off MSRP:</span>
                    <span className="mini-cart__amount-saved">{useFormatUSD(totalSavings / 100)}</span>
                  </div>
                )}

                <div className="cart-recap__price-line text--pull">
                  <span className="cart-recap__price-line-label">Subtotal:</span>
                  <span className="cart-recap__price-line-price">{useFormatUSD(totalPrice / 100)}</span>
                </div>

                
                
                
                {/* <div className="mini-cart__button-container hidden-phone">
                  <div className="button-group button-group--loose button-group--fit">
                    <a className="button button--primary" href="#looking_for0">Complete Your Quote Request!</a>
                  </div>
                </div> */}


                {/* START SHIPPING ESTIMATOR RESULTS */}
                <div id="shipping-estimator-results" 
                  className={`mini-cart__recap-price-line text--pull estimate-shipping__collapsible card__collapsible ${showShippingResults || shippingError ? 'expanded' : ''}`}
                  style={{ height: showShippingResults || shippingError ? 'auto' : '0' }}
                >

                    {shippingError && (
                      <div className="shipping-estimator__error" style={{ color: 'red', marginTop: '10px' }}>
                        {shippingError}
                      </div>
                    )}

                    {showShippingResults && (
                      
                      <>
                        {shippingRates.length === 0 && !shippingError ? (
                          <p>No shipping rates available for your location.</p>
                        ) : shippingRates.length === 0 ? null : (
                          <>
                            {shippingRates.some(rate => rate.code === 'backup_rate') && (
                              <div className="cart-recap__price-line-label shipping-estimator__error" style={{ color: 'red', marginBottom: '15px', padding: '10px', backgroundColor: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: '4px' }}>
                                ⚠️ Some shipping rates shown are backup rates and may not reflect actual shipping costs. Please contact us for accurate pricing.
                              </div>
                            )}
                            {/* <div className="cart-recap__price-line-price"> */}
                              {shippingRates.map((rate, index) => (
                                <>
                                  
                                  <span className="cart-recap__price-line-label" >{rate.name}:</span>
                                  <span className="cart-recap__price-line-price">{useFormatUSD(rate.price)}</span>
                                  {/* {rate.name}: {useFormatUSD(rate.price)} */}


                                  {/* {rate.code === 'backup_rate' && (
                                    <div className="shipping-estimator__error" style={{ color: 'red', marginTop: '5px', fontSize: '0.9em' }}>
                                      ⚠️ This is a backup shipping rate and may not reflect actual shipping costs. Please contact us for accurate pricing.
                                    </div>
                                  )} */}
                                </>
                              ))}
                            {/* </div> */}
                          </>
                        )}
                        </>
                      
                    )}
                  
                </div>
                {/* END SHIPPING ESTIMATOR RESULTS */}



              </div>




              {/* <div className={`shipping-estimator-outer ${!formData?.zip_code || !formData?.state || !isZipCodeValid(formData?.zip_code) || showShippingResults ? 'hidden' : ''}`}>     */}
              <div className={`shipping-estimator-outer ${!formData?.zip_code || !formData?.state || !isZipCodeValid(formData?.zip_code) ? 'hidden' : ''}`}>

                <div className="mini-cart__recap extra-info">

                  {/* <button 
                    type="button" 
                    className="card__collapsible-button accordion-toggle estimate-shipping__toggle" 
                    onClick={() => setShowShippingResults(!showShippingResults)}
                    aria-expanded={showShippingResults}
                    aria-controls="shipping-estimator"
                  > */}
                    {/* <span className="estimate-shipping__icon"></span> */}


                  {/* <div className="cart-recap__price-line text--pull">
                    <span className="cart-recap__price-line-label estimate-shipping__text">Estimate Shipping {formData.zip_code && formData.state ? '(' + formData.zip_code + ', ' + formData.state + ')' : ''}</span>
                    { isLoadingShipping && <span className="loader"></span> }
                  </div> */}

                  
                  <div id="shipping-estimator" >
                      
                    <div className="form__input-row">
                      
                      <div className="form__input-wrapper">
                        <button  
                          type="button" 
                          // className="button button--primary estimate-shipping-btn" 
                          className={`button button--primary estimate-shipping-btn ${!formData?.zip_code || !formData?.state || !isZipCodeValid(formData?.zip_code) || showShippingResults? 'button--disabled' : ''}`}
                          onClick={fetchShippingRates}
                          disabled={isLoadingShipping || !formData?.zip_code || !formData?.state || !isZipCodeValid(formData?.zip_code)}
                        >
                        {isLoadingShipping ? 'Calculating...' : `Estimate Shipping ${formData.zip_code && formData.state ? '(' + formData.zip_code + ', ' + formData.state + ')' : ''}`}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

                


              </div>


              

              <div className="mini-cart__recap extra-info">
                <div className="mini-cart__recap-price-line">
                <p>View our <button className="link link--primary link--underline" data-action="open-modal" aria-controls="modal-shipping-policy" aria-label="View Our Shipping Policy">shipping policy</button>.</p>
                </div>
              </div>

              <div className="mini-cart__recap extra-info lock-in-message-container">
                <p className="lock-in-message"><strong>Plan With Confidence.</strong> See the exact total for your project, including delivery to your site. Start your planning with a free, no-obligation quote.</p>
              </div>

              <div className="mini-cart__recap extra-info">
                <div className="mini-cart__recap-price-line">
                  <span>Need Help?</span>
                  <span>Contact Us at <a className="link link--primary link--underline" href="tel:888.920.4628">888.920.4628</a></span>
                </div>
              </div>

            </div>
          </div>


          

          

        </div>
      </div>
    </div>
  );
}
  
  